import {
  TraderDBAccount,
  TradingAccount,
  Symbol,
  SecurityTypes,
} from '@qep/types/src';

export const getTradingAccountFromAccountId = (accounts: TraderDBAccount[], accountId: string): TradingAccount | undefined => {
  let traderDbAccount: TraderDBAccount | undefined = accounts.find(acc => acc.id === accountId);
  if (!traderDbAccount && accounts[0].id.includes('-')) {
    console.warn('WARNING: Account IDs contain dashes but old saved defaults do not. This is a dangerous comparison');
    traderDbAccount = accounts.find(acc => acc.id.replaceAll('-', '') === accountId);
  }

  if (traderDbAccount) {
    const tradingAccount: TradingAccount & {products: string[]} = {
      accountId: traderDbAccount?.neovestAccount,
      id: traderDbAccount.id,
      tradeIntentionId: traderDbAccount.tradeIntentions.length > 0 ? traderDbAccount.tradeIntentions[0].id : '',
      execCode: traderDbAccount?.code,
      accountCode: traderDbAccount?.code,
      description: traderDbAccount?.description,
      memo: traderDbAccount.memo || '',
      clearingString: traderDbAccount?.clearingString,
      notes: [
        traderDbAccount.tradeIntentions[0]?.tradeIntentionName || '',
        traderDbAccount.customText2 || '',
        traderDbAccount.customText3 || '',
      ],
      products: traderDbAccount?.productSpecifications.map(product => product.symbol),
    };
    return tradingAccount;
  }
};

export const getAllAccountsForSymbol = (accounts: TraderDBAccount[], symbol: Symbol): TraderDBAccount[] => {
  const {segmentMic} = symbol;
  const rootSymbol = symbol.secType === SecurityTypes.Option
    ? (symbol.underlyingRootSymbol ?? symbol.rootSymbol)
    : symbol.rootSymbol;
  const results: TraderDBAccount[] = accounts.filter(acc => {
    const result = acc.productSpecifications?.find(spec => spec.symbol === rootSymbol && spec.exchangeName === segmentMic);
    return Boolean(result);
  });

  return results;
};
